import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface NombrePasoProps {
  nombre: string;
  onNombreChange: (nombre: string) => void;
}

const NombrePaso: React.FC<NombrePasoProps> = ({ nombre, onNombreChange }) => {
  return (
    <Card className='pb-1'>
      <CardHeader className='pb-1'>
        <CardTitle>Paso 1: ¿Cómo te llamas?</CardTitle>
        <CardDescription>Empecemos por tu nombre. Por favor, ingrésalo tal como aparece en tu cédula.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-1">
            <Label htmlFor="nombre">Tu nombre completo</Label>
            <Input
              id="nombre"
              type="text"
              placeholder="Por ejemplo: María González"
              value={nombre}
              onChange={(e) => onNombreChange(e.target.value)}
              required
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NombrePaso;
